import request from '../../utils/request';

export default () => request('/master-data');
